import { User } from '@shared-types/domain'

function stringify(input: unknown) {
  if (typeof input === 'string') {
    return input
  }

  const maybeError = input as Error | undefined
  if (maybeError?.stack && maybeError?.message) {
    // Errors format better when using the stack instead of JSON.stringify
    return maybeError.stack
  }

  return JSON.stringify(input)
}

/*
 * This takes a log string and formats in the variables. For example:
 * s: "My name is %s", params: ["bob"]
 * becomes "My name is Bob"
 *
 * If s is not a string, then just return the raw value(s)
 */
function formatString(s: unknown, params: unknown[]) {
  if (typeof s === 'string') {
    return params.reduce((p, c) => (p as string).replace(/%s/, stringify(c)), s)
  }

  if (params.length > 0) {
    return [s, ...params]
  }

  return s
}

/*
 * Create a logger that has the same interface as the Winston logger
 * in the backend, so that we can have a consistent logging experience
 * across the whole stack.
 */
export function getLogger(module: string) {
  return {
    log: (message: unknown, ...rest: unknown[]) => {
      console.log({ module, message: formatString(message, rest) })
    },
    info: (message: unknown, ...rest: unknown[]) => {
      console.info({ module, message: formatString(message, rest) })
    },
    error: (message: unknown, ...rest: unknown[]) => {
      console.error({ module, message: formatString(message, rest) })
    },
    debug: (message: unknown, ...rest: unknown[]) => {
      console.debug({ module, message: formatString(message, rest) })
    },
    warn: (message: unknown, ...rest: unknown[]) => {
      console.warn({ module, message: formatString(message, rest) })
    },
  }
}

const LOGGER = getLogger('logException')

export function logException(error: Error, user?: User) {
  LOGGER.error('User: %s - Error: %s', user?._id, error.message)
}
